var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaceholderImgProduct(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 25,
    viewBox: "0 0 32 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6 0.899994H2.10001C1.54772 0.899994 1.10001 1.34771 1.10001 1.89999V23.3C1.10001 23.8523 1.54772 24.3 2.10001 24.3H30.6C31.1523 24.3 31.6 23.8523 31.6 23.3V1.89999C31.6 1.34771 31.1523 0.899994 30.6 0.899994Z",
    stroke: "black",
    strokeWidth: 0.4,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8 10.7C8.12549 10.7 9.2 9.62549 9.2 8.3C9.2 6.97452 8.12549 5.89999 6.8 5.89999C5.47452 5.89999 4.39999 6.97452 4.39999 8.3C4.39999 9.62549 5.47452 10.7 6.8 10.7Z",
    stroke: "black",
    strokeWidth: 0.4,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7 19.3L14.6 11.2L20.3 17.2",
    stroke: "black",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7 13.8L23.1 7.89999L17.1 13.8",
    stroke: "black",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderImgProduct);
export default __webpack_public_path__ + "static/media/PlaceholderImgProduct.e86d818d04aaaf0dc4a726e802acc6f1.svg";
export { ForwardRef as ReactComponent };